import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  makeStyles,
  CardMedia,
  Box,
  Divider,
} from "@material-ui/core";

import { useState, useContext } from "react";
import DialogTitle from "./SFDialogTitle";
import TextFieldNoBorder from "../components/TextFieldNoBorder";
import { PaymentCreateContext } from "../pages/payment/payment-addproduct/PaymentCreateContext";
import PointasCash from "../models/PointasCash";
import PointsIcon from "../assets/points.png";
import settings from "../utils/settings";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: 667,
    // height: 408,
    margin: "0 auto",
    paddingTop: 50,
  },

  dialogpaper: {
    margin: 0,
    width: 550,
    // height: 408,
    maxWidth: 667,
    //  maxHeight: 408,
    borderRadius: 12,
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
    alignItems: "center",
  },
  pointsandTextContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyItems: "center",
    alignSelf: "center",
  },
  points: {
    fontSize: 28,
  },
  pointsIconTop: {
    width: 26,
    height: 26,
    marginLeft: 5,
  },
  pointTextField: {
    marginTop: 31,
    width: 426,
    height: 66,
  },
  button: {
    height: 69,
    minHeight: 69,
    fontSize: 26,
    margin: "0 !important",
    borderRadius: "0px 0px",
  },
  dialogAction: { padding: 0 },
}));

const PointasCashDialog = ({ open, onClose }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const [state, dispatch] = useContext(PaymentCreateContext);
  const [pointValue, setPointValue] = useState(
    state.pointasCash
      ? state.pointasCash?.point === 0
        ? ""
        : state.pointasCash.point
      : ""
  );

  const onClosewithClearValue = () => {
    setPointValue("");
    onClose();
  };

  return (
    <Dialog
      onClose={onClosewithClearValue}
      aria-labelledby="customized-dialog-title"
      open={open}
      classes={{ root: classes.allContainer, paper: classes.dialogpaper }}
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={() => {
          setPointValue("");
          dispatch({
            type: "HIDE_POINT_AS_CASH",
            payload: null,
          });
        }}
        title={
          <Typography
            style={{ color: "#FA9917", fontSize: 30, paddingTop: 30 }}
          >
            {translate("ra.text.pointasCash")}
          </Typography>
        }
        icon={PointsIcon}
      ></DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <Typography align="center">
          {translate("ra.text.addProduct.youhavePoint")}
        </Typography>
        <Box className={classes.pointsandTextContainer}>
          <Typography align="center" className={classes.points}>
            {state.member
              ? Number(
                  state.member.lifetime_value?.remaining_reward ?? 0
                ).toLocaleString()
              : null}
          </Typography>
          <CardMedia image={PointsIcon} className={classes.pointsIconTop} />
        </Box>
        <PointtoCashTextField point={pointValue} setPoint={setPointValue} />
        <Typography
          variant="caption"
          style={{
            alignSelf: "flex-end",
            marginRight: "35px",
            color: "orange",
          }}
        >
          {pointValue === ""
            ? null
            : `${translate("ra.text.remaining")}
                ${
                  state.member
                    ? Number(
                        (state.member.lifetime_value.remaining_reward ?? 0) -
                          pointValue
                      ).toLocaleString()
                    : null
                }`}
        </Typography>
        {/* <TextField
          variant="outlined"
          onFocus={(event) => event.target.select()}
          helperText={
            pointValue === ""
              ? null
              : `${translate("ra.text.remaining")}
                ${
                  state.member
                    ? Number(
                        state.member.lifetime_value.remaining_reward -
                          pointValue
                      ).toLocaleString()
                    : null
                }`
          }
          classes={{ root: classes.pointTextField }}
          value={pointValue}
          onChange={(e) => setPointValue(e.target.value)}
          type="number"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <CardMedia
                  image={PointsIcon}
                  className={classes.pointsIconTop}
                />
              </InputAdornment>
            ),
          }}
          align="right"
        /> */}
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <Button
          onClick={() => {
            const adjustedPoint =
              calculateHighestPossiblePointasCash(pointValue);
            setPointValue(adjustedPoint);
            dispatch({
              type: "APPLY_POINT_AS_CASH",
              payload: { points: new PointasCash(adjustedPoint) },
            });
            dispatch({
              type: "HIDE_POINT_AS_CASH",
            });
          }}
          color="primary"
          fullWidth
          variant="contained"
          classes={{ contained: classes.button }}
          disabled={
            (Number(pointValue) !== 0 &&
              (pointValue === "" ||
                pointValue < 0 ||
                pointValue > state.member?.lifetime_value.remaining_reward ||
                (pointValue !== 0 && isLowerThanMinimum(pointValue)))) ||
            !state.member?.lifetime_value.remaining_reward
              ? true
              : false
          }
        >
          {translate("ra.text.addProduct.applyPoint")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const usePointtoCashStyles = makeStyles((theme) => ({
  container: {
    border: "1px solid orange;",
    borderRadius: 6,
    display: "grid",
    gridTemplateColumns: "150px 50px 10px 150px 50px",
    alignItems: "center",
    gap: 5,
    minHeight: 48,
    padding: "5px 12px 5px 12px",
    boxSizing: "border-box",
    marginTop: 40,
    marginBottom: 20,
  },
  point: {
    color: theme.orange,
    fontWeight: "bolder",
    fontSize: 30,
    marginLeft: 0,
  },
  pointPlaceholder: {
    color: theme.gray,

    fontSize: 16,
    marginLeft: 0,
  },

  pointsIcon: {
    width: 20,
    height: 20,
  },
  cashValue: {
    fontWeight: "bolder",
    fontSize: 30,
    marginLeft: 0,
    color: theme.orange,
    opacity: 0.5,
  },
  thb: {
    color: theme.orange,
  },
}));
const PointtoCashTextField = ({ point, setPoint }) => {
  const classes = usePointtoCashStyles();
  const translate = useTranslate();
  return (
    <Box className={classes.container}>
      <TextFieldNoBorder
        inputProps={{ min: 0, style: { textAlign: "center" } }}
        className={point === "" ? classes.pointPlaceholder : classes.point}
        type="number"
        value={point}
        onFocus={(event) => event.target.select()}
        onChange={(e) => setPoint(Math.abs(Math.floor(e.target.value)))}
        placeholder={translate("ra.text.enterYourPoints")}
      />
      <CardMedia image={PointsIcon} className={classes.pointsIcon} />
      <Divider style={{ height: 50 }} orientation="vertical" />
      <Typography align="center" className={classes.cashValue}>
        {calculateCashtoGet(point)}
      </Typography>
      <Typography className={classes.thb}>THB</Typography>
    </Box>
  );
};

const calculateCashtoGet = (point) => {
  const { redeemCash, redeemPoint } = settings();
  return Math.floor((point * redeemCash) / redeemPoint);
};

const calculateHighestPossiblePointasCash = (point) => {
  const { redeemCash, redeemPoint } = settings();
  if (redeemCash > redeemPoint) return point;
  const rate = redeemPoint / redeemCash;

  return point - (point % rate);
};

const isLowerThanMinimum = (point) => {
  const { redeemCash, redeemPoint } = settings();
  const rate = redeemPoint / redeemCash;
  return point < rate;
};

export default PointasCashDialog;
